
import "./App.css"; // Import the CSS file for styling
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // added

const API_ROOT = "https://www.legalexpertsindia.in";

const Admin = () => {
  
  const [isAdmin, setIsAdmin] = useState(!!localStorage.getItem("adminToken"));
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

 const navigate = useNavigate(); // moved/kept here

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_ROOT}/api/admin/login`, { username, password });
      localStorage.setItem("adminToken", res.data.token);
      setIsAdmin(true);
      setUsername("");
      setPassword("");

      navigate("/Dashboard"); // Navigate to the dashboard after successful login

    } catch (err) {
      console.error("Login failed:", err);
      alert("Login failed");
    }
  };


  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    alert("You have been logged out.");
    setIsAdmin(false);

  }; 



  return (
  
    <div>
      <img src="/admin.jpg" alt="Header" />  

      {!isAdmin ? (
        <form onSubmit={handleLogin} style={{ maxWidth: 400, margin: "0 auto 2rem", display: "flex", flexDirection: "column", gap: 8, alignItems: "center" }}>
          <span style={{ fontSize: 40, marginBottom: 8 }}>🔒</span>
          <h2>Admin Login</h2>
          <input placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <button type="submit">Login</button>
        </form>
      ) : (
        <div style={{ maxWidth: 700, margin: "0 auto 2rem" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
           

           <marquee direction="right"> <h3> Welcome Admin ! </h3> </marquee>
                 
            
          </div>
          <button onClick={handleLogout}>Logout</button>
        </div>
      )}


      </div>
 
  );
};

export default Admin;
// ...existing code...
